import { I18n } from '@calendly/i18n'
import { useDropdown } from '@calendly/ui/components/dropdown'
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons'
import { primaryColorL1 } from '@calendly/ui/theme'

import { useGetUserQuery } from 'common'
import { DateRangePicker } from 'components/core/date_range'
import { Periods } from 'constants/meetings'

import { FilterLayout } from './filter_layout'
import { DateRangeContainer, DateDropdownButton } from './styles'
import { useDateRangeLabel } from './use_date_range_label'

// This component is reused in SULs, so it's a good candidate for a shared component
export const DateRange = ({ params, onApply, isSULFilter = false, useColumnLayout = false }) => {
  const { period, start_date: startDate, end_date: endDate } = params
  const { data: { timezone } } = useGetUserQuery()

  const [togglePicker, Dropdown, isPickerOpen] = useDropdown()

  const onChange = (values) => {
    if (values.period === Periods.FIXED) {
      onApply({
        ...params,
        period: values.period,
        start_date: values.startDate,
        end_date: values.endDate
      })
    } else {
      onApply({
        ...params,
        period: values.period === Periods.ALL_TIME ? Periods.UPCOMING : values.period,
        start_date: null,
        end_date: null
      })
    }
  }

  const label = useDateRangeLabel(period, startDate, endDate)

  const labelText = isSULFilter
    ? I18n.t('publisher.scheduling.shared.filter.labels.date_created')
    : I18n.t('publisher.meetings.filter_modal.dates.label')

  return (
    <FilterLayout label={labelText} useColumnLayout={useColumnLayout}>
      <DateDropdownButton onClick={togglePicker}>
        {label}
        {isPickerOpen
          ? <ArrowChevronUpMiniIcon color={primaryColorL1} />
          : <ArrowChevronDownMiniIcon color={primaryColorL1} />}
      </DateDropdownButton>
      <Dropdown>
        <DateRangeContainer isSULFilter={isSULFilter}>
          <DateRangePicker
            period={period}
            startDate={startDate}
            endDate={endDate}
            timezone={timezone}
            onChange={onChange}
            isMIPage
          />
        </DateRangeContainer>
      </Dropdown>
    </FilterLayout>
  )
}
